module.exports = __webpack_public_path__ + "img/NG.153cbb4e.png";